import axios from 'axios';
import { AccountType, LoadingState } from 'globals/types';

interface BasicStore {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  set: (data: any) => void;
  updateStatus: (state: LoadingState) => void;
}

interface PerformSetActionProps {
  store: BasicStore;
  endpoint: string;
  userId?: string | null;
  accountType?: AccountType;
  transactionId?: string;
}

export const getPopulatedEndpoint = ({
  endpoint,
  userId,
  accountType,
  transactionId,
}: {
  endpoint: string;
  userId?: string | null;
  accountType?: AccountType;
  transactionId?: string;
}): string => {
  return endpoint
    .replace('{user_id}', userId || '{user_id}')
    .replace('{account_type}', accountType || '{account_type}')
    .replace('{transaction_id}', transactionId || '{transaction_id}');
};

export const isStoreInitialized = (currentState: LoadingState): boolean => {
  return currentState === LoadingState.SUCCESS;
};

export const performSetAction = async ({
  store,
  endpoint,
  userId,
  accountType,
}: PerformSetActionProps): Promise<void> => {
  store.updateStatus(LoadingState.LOADING);
  try {
    const url = getPopulatedEndpoint({
      endpoint,
      userId,
      accountType,
    });
    const { data } = await axios.get(url);
    store.set(data);
    store.updateStatus(LoadingState.SUCCESS);
  } catch (e) {
    // eslint-disable-next-line no-console
    console.log('Setting Store FAILED: ', e);
    store.updateStatus(LoadingState.FAILED);
  }
};
